export default "__VITE_ASSET__CWeqTxzg__"